import { IMAGES } from '../../constants/image'
import './IntroScreen.css'
import { DefaultScreenProps } from '../defaultScreenProps'
import { useRef, useEffect } from 'react'
import { useSkipNarration } from '../../hooks/useSkipNarration'
import { SkipHint } from '../../components/SkipHint/SkipHint'

type IntroScreenProps = DefaultScreenProps & {
  sayIntroCopy: () => void
  skipNarration: () => void
}

export const IntroScreen = ({
  sayIntroCopy,
  skipNarration,
}: IntroScreenProps) => {
  const audioPlayedRef = useRef(false)

  useEffect(() => {
    if (!audioPlayedRef.current) {
      sayIntroCopy()
      audioPlayedRef.current = true
    }
  }, [sayIntroCopy])

  useSkipNarration(skipNarration)

  return (
    <div className="introScreenContainer">
      <img
        className="introScreenImage"
        src={IMAGES.intro}
        alt="An angry trolley barreling down the tracks"
      />
      <SkipHint />
    </div>
  )
}
